import {ApiModel} from './api-model';
import {Privilege} from './privilege';

export class UserProfile extends ApiModel {

  id: number;
  value: string;
  privileges: Privilege[];

  constructor(data: any) {
    super(data);
    if (data.privileges) {
      this.privileges = data.privileges.map(privilege => new Privilege(privilege));
    } else {
      this.privileges = [];
    }
  }

  hasPrivilege(privilege: Privilege): boolean {
    return !!this.privileges.find(p => p.action === privilege.action && p.component === privilege.component);
  }

}



// WEBPACK FOOTER //
// ./src/app/models/user-profile.ts